import moment from 'moment';
import Cookies from 'universal-cookie';

const calculateBreakViolation = (startTime, maxBreakDuration) => {
  if (!startTime) return 0;

  const cookies = new Cookies();
  const timezone = cookies.get('organization')?.timezone;

  const target = moment.tz(startTime, timezone);

  const limit = target.clone().add(maxBreakDuration, 'minutes');

  const now = moment.tz(timezone);

  const diff = now.diff(limit, 'seconds');

  return diff;
};

export default calculateBreakViolation;
